import {ASSETS_HOST} from '../../consts.js';
import {timer} from '$lib/utils/timer.js';
import type {WordId} from '$lib/classes/data/_primitives';

export class VerbConjugations {

    // TODO make private and use getConjugations method instead !!
    value: Record<string, string> = {}

    constructor() { }

    async init() {
        const timer_verbConjugations = timer('verbConjugations.init')
        try {
            const response = await fetch(`${ASSETS_HOST}/vc.json`)
            if (response.ok) {
                Object.assign(this.value, await response.json())
            } else {
                // noinspection ExceptionCaughtLocallyJS
                throw new Error('reponse.status ' + response.status)
            }
        } catch (error) {
            throw new Error('ERROR VerbConjugations.init', {cause: error})
        }
        timer_verbConjugations()
    }

    getConjugations(id: WordId): string | undefined {
        return this.value[id]
    }
}